import { createFileRoute } from '@tanstack/react-router';

import { RunAuditView } from '@/features/gap-review/components/RunAuditView';

export const Route = createFileRoute('/_dashboard/gap-review/run/$executionId')(
  {
    component: RunAuditRoute,
  }
);

function RunAuditRoute() {
  const { executionId } = Route.useParams();

  // Keyed on the id so switching executions from the picker remounts rather than
  // rendering the previous run's sections against the next one's data.
  return <RunAuditView executionId={executionId} key={executionId} />;
}
